module.exports = __webpack_public_path__ + "static/media/hero_image_1.517a6d6a.svg";